<script>
import appConfig from '@src/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  data() {
    return {
      lockDialogVisible: false,
    }
  },
  mounted() {
    const appDirection = window.matchMedia('(orientation: landscape)')
    this.handleOrientationChange(appDirection)
    appDirection.addListener(this.handleOrientationChange)
  },
  methods: {
    handleOrientationChange(screenDirection) {
      this.lockDialogVisible = !screenDirection.matches
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
    <el-dialog
      title="網站以橫向模式瀏覽最佳"
      :visible.sync="lockDialogVisible"
      top="0"
      width="40%"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
      lock-scroll
    >
      <p style="text-align: center;">請旋轉您的裝置</p>
    </el-dialog>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';
@import '@src/design/global.scss';

*,
*::before,
*::after {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}
html {
  font-size: 14px;
  line-height: 1.15;
  -webkit-tap-highlight-color: transparent;
}
body {
  @extend %font-content;

  height: 100vh;
  background: $color-body-bg;
  -webkit-overflow-scrolling: touch;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
h1 {
  @extend %font-heading;

  font-size: ms(6);
  letter-spacing: $font-letter-spacing-base;
}

h2 {
  @extend %font-heading;

  font-size: ms(5);
  letter-spacing: $font-letter-spacing-base;
}

h3 {
  @extend %font-heading;

  font-size: ms(4);
  margin-block-start: ms(4) / 1.5;
  margin-block-end: ms(4) / 1.5;
  letter-spacing: $font-letter-spacing-base;
}

h4 {
  @extend %font-heading;

  font-size: ms(3);
  margin-block-start: ms(3) / 1.5;
  margin-block-end: ms(3) / 1.5;
  letter-spacing: $font-letter-spacing-base;
}

h5 {
  @extend %font-heading;

  font-size: ms(2);
  margin-block-start: ms(2) / 1.5;
  margin-block-end: ms(2) / 1.5;
  letter-spacing: $font-letter-spacing-small;
}

h6 {
  @extend %font-heading;

  font-size: ms(1);
  margin-block-start: ms(1) / 1.5;
  margin-block-end: ms(1) / 1.5;
  letter-spacing: $font-letter-spacing-small;
}

input {
  background: none;
}

img {
  max-width: 100%;
}

[hidden] {
  display: none;
}

// ===
// Vendor
// ===

#nprogress {
  .bar {
    background: $color-primary;
  }

  .spinner-icon {
    border-top-color: $color-primary;
    border-left-color: $color-primary;
  }
}
</style>
